export const pages = {
	'linkOutPL': { id: 'linkOutPL', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
